/* eslint-disable prettier/prettier */
import axios from 'axios';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import _ from 'lodash';
import toastr from 'toastr';
import { API_URL, ARTICLE_API } from '../constants/api';
import {limitOfArticles} from '../constants';
import * as types from '../actions/actionTypes';
import {
  addArticles,
  changeArticles,
  changeOffset,
  deleteArticleSuccess,
  loadMore,
  offLoad,
  updateArticlesSuccess,
} from '../actions';
import checkValidArticles from '../utils/filterArticles';

const getArticles = ({ offset, limit, tag, author, favorited, token }: any) =>
  axios({
    method: 'get',
    url: `${API_URL}/articles?limit=${limit}
		${offset ? `&offset=${offset}` : ''}
		${tag ? `&tag=${tag}` : ''}
		${author ? `&author=${author}` : ''}
		${favorited ? `&favorited=${favorited}` : ''}`,
    headers: {
      Authorization: token ? `Token ${token}` : '',
    },
  });

const postArticle = ({ title, description, body, tags }: any) => {
  return axios.post(
    ARTICLE_API,
    {
      article: {
        title,
        description,
        body,
        tagList: tags,
      },
    },
    {
      headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    }
  );
};

function* getArticlesAsync(action: any) {
  try {
    let results: any[] = [];
    yield put(changeOffset(0));
    while (results.length < 20) {
      const offset = yield select((state) => state.offset);
      const data = yield call(getArticles, { ...action.payload, offset });
      yield put(changeOffset(offset + limitOfArticles));
      results = _.unionBy(
        [...results, ...checkValidArticles(data.data.articles)],
        'title'
      );
      if (data.data.articles.length < limitOfArticles) {
        break;
      }
    } 
    yield put(offLoad());
    yield put(changeArticles(results));
  } catch (error) {}
}

function* getMoreArticlesAsync(action: any) {
  try {
    let results: any[] = [];
    while (results.length < 20){
      const offset = yield select((state) => state.offset);
      const data = yield call(getArticles, {
        ...action.payload,
        offset,
      });
      yield put(changeOffset(offset + limitOfArticles));
      results = _.unionBy(
        [...results, ...checkValidArticles(data.data.articles)],
        'title'
      );
      if (data.data.articles.length < limitOfArticles) {
        yield put(loadMore(false));
        break;
      } else {
        yield put(loadMore(true));
      }
    }
    yield put(addArticles(results));
  } catch (error) {}
}

function* postArticleAsync(action: any) {
  try {
    const response = yield call(postArticle, action.payload);
    yield put({
      type: types.POST_ARTICLE_SUCCESS,
      payload: response.data.article,
    });
  } catch (error) {
    yield put({ type: types.POST_ARTICLE_FAIL, message: error.message });
  }
}

const deleteArticle = ({ slug } : any) => {
  return axios.delete(`${ARTICLE_API}/${slug}`,{
    headers: {
      Authorization: `Token ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json',
    },
  });
}

function* deleteArticleAsync(action: any){
  try{
    yield call(deleteArticle, action.payload);
    yield put(deleteArticleSuccess(action.payload.slug))
    toastr.success('Article deleted.');
  }catch(error) {}
}

const updateArticle = ({ title, description, body, tags, slug } : any) => {
  return axios.put(`${ARTICLE_API}/${slug}`, {
    article: {
      title,
      description,
      body,
      tagList: tags,
    },
  },{
    headers: {
      Authorization: `Token ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json',
    },
  });
}

function* updateArticleAsync(action: any) {
  try{
    const response = yield call(updateArticle, action.payload);
    yield put(updateArticlesSuccess(response.data.article));
  }catch(error){}
}

function* articlesWorker() {
  yield takeLatest(types.GET_ARTICLES_REQUEST, getArticlesAsync);
  yield takeLatest(types.GET_MORE_ARTICLES_REQUEST, getMoreArticlesAsync);
  yield takeLatest(types.POST_ARTICLE_REQUEST, postArticleAsync);
  yield takeLatest(types.DELETE_ARTICLE, deleteArticleAsync);
  yield takeLatest(types.UPDATE_ARTICLES_REQUEST, updateArticleAsync);
}

export default articlesWorker;
